// @ts-check

const buildLineItemLookup = (
  groupings,
  lineItemLookup,
  constraintCellLookup
) => {
  for (const g of groupings) {
    for (const li of g.lineItems) {
      // for performance, we don't want to create a new object

      lineItemLookup[li.id] = li;
    }
    if (constraintCellLookup) {
      for (const c of g.constraints) {
        // for performance, we don't want to create a new object

        constraintCellLookup[c.id] = c;
      }
    }
  }
  return {
    lineItemLookup,
    constraintCellLookup,
  };
};

export default buildLineItemLookup;
